export const INIT_HOTEL_PRE_RESERVATION = "INIT_HOTEL_PRE_RESERVATION";
export const SET_DISPLAY_HOTEL_PRE_RESERVATION_CONFIRMATION =
  "SET_DISPLAY_HOTEL_PRE_RESERVATION_CONFIRMATION";
